module.exports = __webpack_public_path__ + "img/271.05048b6b.jpg";